import { Switch } from '@material-ui/core';
import styled from 'styled-components';
import { ASSETS } from '../../utils/config';
import { device } from '../../utils/device';
import { sliderToOpacity } from '../../utils/helpers';
import { colors } from '../../utils';

export const Wrapper = styled.div`
  position: relative;
  z-index: 0;
`;

export const WheelWallpaperImage = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
  background-image: ${({ currentBg, bgWallpaper }) =>
    currentBg === 2 && bgWallpaper !== ''
      ? bgWallpaper?.startsWith('data:')
        ? `url(${bgWallpaper})`
        : bgWallpaper?.startsWith('http')
          ? `url(${bgWallpaper})`
          : bgWallpaper
      : bgWallpaper};
  object-fit: contain;
  background-position: stretch;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100% 100%;
  opacity: ${({ wallpaperTransparency }) => sliderToOpacity(wallpaperTransparency)};
  filter: hue-rotate(${({ wallpaperHuePercentage }) =>
    ((wallpaperHuePercentage ?? 0) / 100) * 360}deg);
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ wallpaperHueColor }) =>
      wallpaperHueColor ?? "#ffffff"};
    opacity: ${({ wallpaperHuePercentage }) =>
      ((wallpaperHuePercentage ?? 0) / 100) * 0.5};
    mix-blend-mode: multiply;
    pointer-events: none;
  }
`;

export const WheelWallpaperColor = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
  background-color: ${({ color }) => color};
  opacity: ${({ wallpaperTransparency }) => sliderToOpacity(wallpaperTransparency)};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${({ showInfo, selectedArc,isMobile }) => {
    if(isMobile && !selectedArc) return "0% 100% 0%";
    if(isMobile && selectedArc) return "0% 50% 50%";
    if (showInfo && !selectedArc) return '30% 70% 0%';
    if (!showInfo && selectedArc) return '0% 70% 30%';
    if (showInfo && selectedArc) return '25% 50% 25%';
    return '25% 50% 25%';
  }};
  padding: 20px;
  min-height: 92vh;
  z-index: 0;
  transition: grid-template-columns 0.5s ease-in-out;

  @media (${device.mobileLandscape}) {
    padding: 10px;
  }
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;

  background: ${({ currentBg, bgWallpaper, color }) => {
    if ((currentBg === 2 || currentBg === 3) && bgWallpaper !== '') {
      return currentBg === 2 ? `url(${bgWallpaper})` : bgWallpaper;
    } else if (currentBg === 0 && !color) {
      return `url(${ASSETS.segmentEditor.DefaultWallpaperForViewWheel})`;
    }
    return color;
  }};
  object-fit: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  opacity: ${({ wallpaperTransparency }) => sliderToOpacity(wallpaperTransparency)};
  filter: hue-rotate(${({ wallpaperHuePercentage }) =>
    ((wallpaperHuePercentage ?? 0) / 100) * 360}deg);
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ wallpaperHueColor }) =>
      wallpaperHueColor ?? "#ffffff"};
    opacity: ${({ wallpaperHuePercentage }) =>
      ((wallpaperHuePercentage ?? 0) / 100) * 0.5};
    mix-blend-mode: multiply;
    pointer-events: none;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CenterColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  transition: transform 0.3s ease-in-out;
  width: 100%;
  transform: ${({ showInfo, selectedArc }) => {
    if (showInfo && !selectedArc) return 'translateX(0)';
    if (!showInfo && selectedArc) return 'translateX(0)';
    return 'translateX(0)';
  }};
`;

export const RightColumn = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
`;

export const WheelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LabelWrapper = styled.div`
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  padding: 0px 8px;
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
`;

export const StyledSwitch = styled(Switch)`
  width: 50px;
  height: 35px;
`;

export const LabelText = styled.p`
  font-family: 'DM Sans';
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  margin: 0;
`;

export const IconView = styled.div`
  width: 40px;
  height: 40px;
  display: none;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 8px;
  position: absolute;
  right: 10px;
  top: 0px;
  cursor: pointer;

  @media (${device.mobileLandscape}) {
    display: flex;
  }
`;

export const HiddenWheelContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  background-color: ${colors.background};
  height: 92vh;

  @media (${device.mobilePortrait}) {
    height: 80vh;
  }
`;

export const FacebookBrowserContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  background-color: ${colors.background};
  height: 92vh;

  @media (${device.mobilePortrait}) {
    height: 80vh;
  }
`;


export const NoDataContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "382px",
  flexDirection: "column",
  backgroundColor: "#fff",
  padding: "24px",
  gap: "24px",
  borderRadius: "8px",
  boxShadow: "0px 0px 9.3px 0px #3B3B3B1C"


});

export const TextContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
});